export default __webpack_public_path__ + "static/media/stepperMob.fa632c7c.svg";